import _ from "lodash";
import {
  getDeliveryPeriodsForEan,
  isAvailableForDelivery,
} from "./productsDelivery";
import { getColorAndSizeForEan, getProductsByNumber } from "./products";

const addSizeToColorData = ({ data, color, size }) => {
  const newData = { ...data };
  if (!color) return data;
  if (newData[color]) {
    newData[color][size] = 0;
  } else {
    newData[color] = { [size]: 0 };
  }

  return newData;
};

export const getDataForMatrixForProductNumberAndDate =
  (context) =>
  ({ number, deliveryPeriodId, sizesByLength }) => {
    const eans = getProductsByNumber(context)[number];
    if (!eans) return {};
    const data = {};

    _.keys(sizesByLength).forEach((length) => {
      const sizes = sizesByLength[length];
      let currentLength = {};
      Object.keys(eans).forEach((eanKey) => {
        if (!_.isObject(eans[eanKey])) return;
        const periods = getDeliveryPeriodsForEan({
          context,
          ean: Number(eanKey),
        });
        if (isAvailableForDelivery(periods, deliveryPeriodId)) {
          const { color, size } = getColorAndSizeForEan({
            number,
            eanKey: Number(eanKey),
            context,
          });

          if (sizes.includes(size)) {
            currentLength = addSizeToColorData({
              data: currentLength,
              size,
              color: color.code,
            });
          }
        }
      });

      data[length] = currentLength;
    });

    return data;
  };
